import React, { useState } from "react";
import ModalPopup from "../../../ModalPopup/ModalPopup";
import NewLineItem from "./NewLineItem";
import useGlobal from "../../../../GlobalState/Store";
import { message } from "antd";

const initialState = {
  publisherType: undefined,
  softwareType: undefined,
  keyToMaintain: undefined,
  keysToUpgrade: [],
  orgType: undefined,
  licenseType: undefined,
  installType: "User",
  installNumber: 1,
  checkBox: false,
  concurrency: false,
  installsPerSeat: null,
  lineItemCost: null,
  maintainanceCostPerSeat: null,
  maintainanceStart: null,
  expDate: null,
  keyType: undefined,
  keyData: "",
  attachFile: [],
  attachReg: [],
};

const AddNewLineItem = (props) => {
  const [globalState, globalActions] = useGlobal();
  //const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  const { addPoLineItem, addToPoLineItemList } = globalActions;
  const {
    purchaseOrder: { poLineItem },
  } = globalState;

  const {
    publisherType,
    softwareType,
    licenseType,
    orgType,
    installType,
    installNumber,
    checkBox,
    installsPerSeat,
    lineItemCost,
    keyType,
    keyData,
    attachFile,
    attachReg,
  } = poLineItem;

  const clearPoLineItem = () => {
    addPoLineItem({ ...initialState });
  };

  const onModalClose = () => {
    setVisible(false);
    clearPoLineItem();
  };

  const showModal = () => {
    setVisible(true);
  };

  const handleCancel = (e) => {
    onModalClose();
  };
  const validatePoLineItem = () => {
    if (
      publisherType &&
      softwareType &&
      installsPerSeat &&
      licenseType &&
      orgType &&
      (installNumber || checkBox) &&
      lineItemCost &&
      keyType.label &&
      installType
    ) {
      if (keyType.label === "File") {
        if (attachFile.length < 1) {
          message.info("Please attach a file or select a different key type.");
          return false;
        }
      } else if (keyType.label === "RegKey") {
        if (attachReg.length < 1) {
          message.info(
            "Please attach a Reg file or select a different key type."
          );
          return false;
        }
      } else if (keyType.label === "String") {
        if (!keyData) {
          message.info(
            "Please enter key string or select a different key type."
          );
          return false;
        }
      }
    } else {
      message.info("Please fill out all mandatory fields.");
      return false;
    }

    return true;
  };
  const removeUnusedKeys = (poLineItem) => {
    let data = poLineItem;
    if (data.keyType.label === "File") {
      data.attachReg = [];
      data.keyData = "";
    }
    if (data.keyType.label === "RegKey") {
      data.attachFile = [];
      data.keyData = "";
    }
    if (data.keyType.label === "String") {
      data.attachReg = [];
      data.attachFile = [];
    }
    if (data.keyType.label === "No Key") {
      data.attachReg = [];
      data.attachFile = [];
      data.keyData = "";
    }
    return data;
  };

  const handleSubmit = () => {
    const validated = validatePoLineItem();
    if (validated) {
      const item = removeUnusedKeys(poLineItem);
      item.itemType = "New Software";
      addToPoLineItemList(item);
      clearPoLineItem();
      onModalClose();
    }
  };
  return (
    <div>
      <ModalPopup
        header="New Software"
        buttonText="New"
        name="Add"
        link={true}
        close="Cancel"
        submit={handleSubmit}
        onModalClose={onModalClose}
        showModal={showModal}
        handleCancel={handleCancel}
        visible={visible}
      >
        <NewLineItem PoClaim={props.PoClaim} />
      </ModalPopup>
    </div>
  );
};

export default AddNewLineItem;
